export default __webpack_public_path__ + "static/media/06.ddb93667.png";